// extracted by mini-css-extract-plugin
export default {"validDepth":"CapacityTable_validDepth__y4r+E","tr":"CapacityTable_tr__CLW2K","wrongDepth":"CapacityTable_wrongDepth__HQG3L","currentZ":"CapacityTable_currentZ__GTVu6"};